<template>
  <div id="app">
    <router-view v-if="isRouterAlive" name="app" />
  </div>
</template>

<script>
import { demo } from "./api/api";
export default {
  data() {
    return {
      isRouterAlive:true
    };
  },
  provide() {
    return {
      boxHeightInit: this.boxHeightInit,
      reload: this.reload
    };
  },
  created() {
    this.$store.commit("setWindowH", document.documentElement.clientHeight);
  },
  methods: {
    boxHeightInit() {
      let { windowHeight } = this.$store.state;
      let box = document.querySelectorAll(".box");
      box.forEach((v, i) => {
        v.style.height = windowHeight - 120 - 35 + "px";
      });
      return windowHeight - 120 - 35;
    },
    reload() {
      this.isRouterAlive = false; //先关闭，
      this.$nextTick(function() {
        this.isRouterAlive = true; //再打开
      });
    }
  }
};
</script>

<style>
</style>
